import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { InputSwitch, InputSwitchChangeEvent } from "primereact/inputswitch";
import { TableSortingSVG } from "../../../../assets/SVGs/TableSortingSVG";
import { EditButtonSVG } from "../../../../assets/SVGs/EditButtonSVG";
import { Vehicle } from "../Vehicle Management/VehicleManagement";
import { HolidayTreeSVG } from "../../../../assets/SVGs/holidayTreeSVG";
import { ROLES } from "../../../../util/roleNameConstants";
import {
  convertEpochtoDate,
  convertEpochToTime,
  convertSecondsToTime,
  removeSecFromDuration,
} from "../../../../helper/DateConverters";
import { InputText } from "primereact/inputtext";
import {
  addTrackerTime,
  approveTimelogByHR,
  fetchTeamLogsData,
} from "../TimeLog Management/Team Logs/fetchData";
import { ApproveTimeLogIconSVG } from "../../../../assets/SVGs/ApproveTimeLogIconSVG";
import { RejectTimeLogIconSVG } from "../../../../assets/SVGs/rejectTimeLogIconSVG";
import { showError } from "../../../../util/ShowStatus";
import { TIMELOG_STATUSES } from "../../../../util/constants";
import { Tooltip } from "primereact/tooltip";

export const tableHeaderTemplate = (
  header: string,
  field: string,
  setSortFilter?: any
) => {
  return (
    <div
      className={`tw-flex tw-justify-between tw-w-full tw-items-center ${
        field !== "" && "tw-cursor-pointer"
      }`}
      onClick={() => {
        if (field !== "") {
          setSortFilter((prevSortFilter: any) => ({
            ...prevSortFilter,
            sortField: field,
            sortOrder: !prevSortFilter.sortOrder,
          }));
        }
      }}
    >
      <span className="tw-font-bold tw-text-[#141414]">{header}</span>
      {field !== "" && (
        <span className="tw-ml-4 tw-mr-0">
          <TableSortingSVG />
        </span>
      )}
    </div>
  );
};

export const actionBodyTemplate = (
  rowData: Vehicle,
  handleEdit: any,
  updateStatus: any,
  isAddButtonDisabled: boolean,
  formValues: any
) => (
  <div className="tw-flex tw-gap-4">
    <Button
      className="p-button-rounded tw-p-0 tw-w-auto tw-h-auto"
      onClick={() => handleEdit(rowData)}
    >
      <EditButtonSVG />
    </Button>
    <InputSwitch
      checked={rowData.isActive}
      onChange={(e: InputSwitchChangeEvent) => {
        updateStatus(rowData.vehicleID, e.value);
      }}
      disabled={
        isAddButtonDisabled && rowData.vehicleID === formValues.vehicleID
      }
    />
  </div>
);

export const accordianHeaderTemplate = (
  data: any,
  isWorkerView: boolean,
  groupedTimes: any
) => {
  const groupKey = isWorkerView ? data.displayName : data.registration_no;
  const totalAppTime = convertSecondsToTime(
    groupedTimes[groupKey]?.totalAppTime || 0
  );
  const totalManagerTime = convertSecondsToTime(
    groupedTimes[groupKey]?.totalManagerTime || 0
  );
  const totalTrackerTime = convertSecondsToTime(
    groupedTimes[groupKey]?.totalTrackerTime || 0
  );

  return (
    <span className="tw-inline-flex tw-justify-between tw-items-center tw-gap-4 table-row-group-header">
      <span className="tw-inline-flex tw-flex-col">
        <span className="tw-text-[#64748B] tw-font-bold tw-text-sm">
          {groupKey}
        </span>
        <div className="tw-flex tw-gap-3">
          <span className="tw-font-medium tw-mr-2 tw-text-[#64748B] tw-text-sm">
            Total Claimed Time :{" "}
            <span className="tw-text-[#152846]">{totalAppTime} hrs</span>
          </span>
          <span className="tw-font-medium tw-mr-2 tw-text-[#64748B] tw-text-sm">
            Total Manager Time :{" "}
            <span className="tw-text-[#152846]">{totalManagerTime} hrs</span>
          </span>
          <span className="tw-font-medium tw-mr-2 tw-text-[#64748B] tw-text-sm">
            Total Tracker Time :{" "}
            <span className="tw-text-[#00AFEE]">{totalTrackerTime} hrs</span>
          </span>
        </div>
      </span>
    </span>
  );
};

export const dateBodyTemplate = (rowData: any) => {
  return (
    <span className="tw-flex tw-items-center tw-gap-2">
      {rowData.isWorkedOnHoliday === 1 && <HolidayTreeSVG />}
      <span className="tw-text-[#64748B] tw-text-sm">
        {convertEpochtoDate(rowData.log_date)}
      </span>
    </span>
  );
};

export const appTimeBodyTemplate = (
  rowData: any,
  setShowTimeLogDetails: any,
  setTimeLogDetails: any
) => {
  // return <Tag value={rowData.status} severity={getSeverity(rowData.status)} />;
  return (
    <div className="tw-flex tw-align-items-center tw-gap-2">
      <span className="tw-text-[#64748B] tw-text-sm">
        {convertEpochToTime(rowData.punch_in)}
      </span>
      <span className="tw-text-[#64748B] tw-text-sm">
        {convertEpochToTime(rowData.punch_out)}
      </span>
      <span
        className="tw-text-[#152846] tw-font-bold tw-text-sm tw-cursor-pointer tw-underline"
        onClick={() => {
          setTimeLogDetails(rowData.timelogdetails);

          setShowTimeLogDetails(true);
        }}
      >
        {removeSecFromDuration(rowData.duration)} {rowData.duration && "hrs"}
      </span>
      {/* <span className="tw-text-[#00AFEE] tw-font-medium tw-text-sm tw-cursor-pointer"
        onClick={() => setShowTimeLogDetails(true)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M12.375 10.6875H14.625C14.9234 10.6875 15.2095 10.569 15.4205 10.358C15.6315 10.147 15.75 9.86087 15.75 9.5625V7.3125C15.75 7.01413 15.6315 6.72798 15.4205 6.517C15.2095 6.30603 14.9234 6.1875 14.625 6.1875H12.375C12.0766 6.1875 11.7905 6.30603 11.5795 6.517C11.3685 6.72798 11.25 7.01413 11.25 7.3125V7.875H6.1875V5.625H6.75C7.04837 5.625 7.33452 5.50647 7.5455 5.2955C7.75647 5.08452 7.875 4.79837 7.875 4.5V2.25C7.875 1.95163 7.75647 1.66548 7.5455 1.4545C7.33452 1.24353 7.04837 1.125 6.75 1.125H4.5C4.20163 1.125 3.91548 1.24353 3.7045 1.4545C3.49353 1.66548 3.375 1.95163 3.375 2.25V4.5C3.375 4.79837 3.49353 5.08452 3.7045 5.2955C3.91548 5.50647 4.20163 5.625 4.5 5.625H5.0625V13.5C5.0625 13.9476 5.24029 14.3768 5.55676 14.6932C5.87322 15.0097 6.30245 15.1875 6.75 15.1875H11.25V15.75C11.25 16.0484 11.3685 16.3345 11.5795 16.5455C11.7905 16.7565 12.0766 16.875 12.375 16.875H14.625C14.9234 16.875 15.2095 16.7565 15.4205 16.5455C15.6315 16.3345 15.75 16.0484 15.75 15.75V13.5C15.75 13.2016 15.6315 12.9155 15.4205 12.7045C15.2095 12.4935 14.9234 12.375 14.625 12.375H12.375C12.0766 12.375 11.7905 12.4935 11.5795 12.7045C11.3685 12.9155 11.25 13.2016 11.25 13.5V14.0625H6.75C6.60082 14.0625 6.45774 14.0032 6.35225 13.8977C6.24676 13.7923 6.1875 13.6492 6.1875 13.5V9H11.25V9.5625C11.25 9.86087 11.3685 10.147 11.5795 10.358C11.7905 10.569 12.0766 10.6875 12.375 10.6875ZM4.5 2.25H6.75V4.5H4.5V2.25ZM12.375 13.5H14.625V15.75H12.375V13.5ZM12.375 7.3125H14.625V9.5625H12.375V7.3125Z" fill="#007AFF"/>
          </svg>
        </span> */}
    </div>
  );
};

export const managerTimeListingBodyTemplate = (
  rowData: any
  // setShowTimeLogDetails: any,
  // setTimeLogDetails: any
) => {
  // return <Tag value={rowData.status} severity={getSeverity(rowData.status)} />;
  return (
    <div className="tw-flex tw-align-items-center tw-gap-2">
      <span className="tw-text-[#64748B] tw-text-sm">
        {rowData.manager_punch_in ? (
          convertEpochToTime(rowData.manager_punch_in)
        ) : (
          <span className=" tw-ml-4 tw-mr-8 tw-font-extrabold  tw-text-sm tw-text-black">
            -
          </span>
        )}
      </span>
      <span className="tw-text-[#64748B] tw-text-sm">
        {rowData.manager_punch_out ? (
          convertEpochToTime(rowData.manager_punch_out)
        ) : (
          <span className="tw-mr-8 tw-font-extrabold tw-text-sm tw-text-black">
            -
          </span>
        )}
      </span>
      <span
        className="tw-text-[#152846] tw-font-bold tw-text-sm"
        // onClick={() => {
        //   setTimeLogDetails(rowData.timelogdetails);

        //   setShowTimeLogDetails(true);
        // }}
      >
        {rowData.manager_duration ? (
          `${removeSecFromDuration(rowData.manager_duration)} hrs`
        ) : (
          <span className="tw-font-extrabold tw-text-sm tw-text-black">-</span>
        )}
      </span>
      {/* <span className="tw-text-[#00AFEE] tw-font-medium tw-text-sm tw-cursor-pointer"
        onClick={() => setShowTimeLogDetails(true)}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M12.375 10.6875H14.625C14.9234 10.6875 15.2095 10.569 15.4205 10.358C15.6315 10.147 15.75 9.86087 15.75 9.5625V7.3125C15.75 7.01413 15.6315 6.72798 15.4205 6.517C15.2095 6.30603 14.9234 6.1875 14.625 6.1875H12.375C12.0766 6.1875 11.7905 6.30603 11.5795 6.517C11.3685 6.72798 11.25 7.01413 11.25 7.3125V7.875H6.1875V5.625H6.75C7.04837 5.625 7.33452 5.50647 7.5455 5.2955C7.75647 5.08452 7.875 4.79837 7.875 4.5V2.25C7.875 1.95163 7.75647 1.66548 7.5455 1.4545C7.33452 1.24353 7.04837 1.125 6.75 1.125H4.5C4.20163 1.125 3.91548 1.24353 3.7045 1.4545C3.49353 1.66548 3.375 1.95163 3.375 2.25V4.5C3.375 4.79837 3.49353 5.08452 3.7045 5.2955C3.91548 5.50647 4.20163 5.625 4.5 5.625H5.0625V13.5C5.0625 13.9476 5.24029 14.3768 5.55676 14.6932C5.87322 15.0097 6.30245 15.1875 6.75 15.1875H11.25V15.75C11.25 16.0484 11.3685 16.3345 11.5795 16.5455C11.7905 16.7565 12.0766 16.875 12.375 16.875H14.625C14.9234 16.875 15.2095 16.7565 15.4205 16.5455C15.6315 16.3345 15.75 16.0484 15.75 15.75V13.5C15.75 13.2016 15.6315 12.9155 15.4205 12.7045C15.2095 12.4935 14.9234 12.375 14.625 12.375H12.375C12.0766 12.375 11.7905 12.4935 11.5795 12.7045C11.3685 12.9155 11.25 13.2016 11.25 13.5V14.0625H6.75C6.60082 14.0625 6.45774 14.0032 6.35225 13.8977C6.24676 13.7923 6.1875 13.6492 6.1875 13.5V9H11.25V9.5625C11.25 9.86087 11.3685 10.147 11.5795 10.358C11.7905 10.569 12.0766 10.6875 12.375 10.6875ZM4.5 2.25H6.75V4.5H4.5V2.25ZM12.375 13.5H14.625V15.75H12.375V13.5ZM12.375 7.3125H14.625V9.5625H12.375V7.3125Z" fill="#007AFF"/>
          </svg>
        </span> */}
    </div>
  );
};

export const trackerTimeBodyTemplate = (props: any) => {
  const isEdit = props.editTrackerTimeRowIndex === props.rowData.timeLogID;

  const handleEditClick = (timeLogID: any) => {
    if (isEdit) {
      props.setEditTrackerTimeRowIndex(null); // Close current row
    } else if (props.editTrackerTimeRowIndex === null) {
      props.setEditTrackerTimeRowIndex(timeLogID); // Open only if no other row is being edited
    }
  };

  // Function to combine date from log_date with selected time (UTC, seconds always 00)
  const combineDateWithTime = (
    logDateEpoch: number,
    selectedTime: Date | null
  ) => {
    if (!selectedTime) {
      return null;
    }
    const logDate = new Date(logDateEpoch * 1000); // Convert log_date to a Date object
    // Use UTC methods to ensure UTC time, seconds always 00
    const combinedDate = Date.UTC(
      logDate.getUTCFullYear(),
      logDate.getUTCMonth(),
      logDate.getUTCDate(),
      selectedTime.getUTCHours(),
      selectedTime.getUTCMinutes(),
      0 // Always set seconds to 00
    );
    return Math.floor(combinedDate / 1000); // Convert to epoch time (UTC)
  };

  // Function to calculate duration in HH:MM format, supporting cross-day time spans
  const calculateDuration = (
    startTimeEpoch: number | null,
    endTimeEpoch: number | null
  ) => {
    if (!startTimeEpoch || !endTimeEpoch) return "00:00";
    const startTime = new Date(startTimeEpoch * 1000);
    const endTime = new Date(endTimeEpoch * 1000);

    let timeDifferenceMs = endTime.getTime() - startTime.getTime();
    if (timeDifferenceMs < 0) {
      timeDifferenceMs += 24 * 60 * 60 * 1000; // Add 24 hours in milliseconds
    }
    const totalSeconds = Math.floor(timeDifferenceMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}`;
  };

  // Handler for tracker_start change
  const handleTrackerStartChange = (e: any) => {
    const selectedTime = e.value;
    if (!selectedTime) {
      props.setAddTrackerTimeData((prev: any) => ({
        ...prev,
        tracker_start: null,
        tracker_duration: "00:00",
      }));
      return;
    }
    // Set the date of selectedTime same as the props.rowData.log_date in UTC, seconds always 00
    const utcSelectedTime = new Date(
      Date.UTC(
        new Date(props.rowData.log_date * 1000).getUTCFullYear(),
        new Date(props.rowData.log_date * 1000).getUTCMonth(),
        new Date(props.rowData.log_date * 1000).getUTCDate(),
        selectedTime.getUTCHours(),
        selectedTime.getUTCMinutes(),
        0 // Always set seconds to 00
      )
    );

    const combinedEpoch = combineDateWithTime(
      props.rowData.log_date,
      utcSelectedTime
    );

    props.setAddTrackerTimeData((prev: any) => ({
      ...prev,
      tracker_start: combinedEpoch,
    }));

    const currentEndTimeEpoch =
      props.addTrackerTimeData.tracker_end || props.rowData.tracker_punch_out;

    if (currentEndTimeEpoch && combinedEpoch) {
      const duration = calculateDuration(combinedEpoch, currentEndTimeEpoch);
      props.setAddTrackerTimeData((prev: any) => ({
        ...prev,
        tracker_duration: duration,
      }));
    }
  };

  // Handler for tracker_end change
  const handleTrackerEndChange = (e: any) => {
    const selectedTime = e.value;
    if (!selectedTime) {
      props.setAddTrackerTimeData((prev: any) => ({
        ...prev,
        tracker_end: null,
        tracker_duration: "00:00",
      }));
      return;
    }
    // Set the date of selectedTime same as the props.rowData.log_date in UTC, seconds always 00
    const utcSelectedTime = new Date(
      Date.UTC(
        new Date(props.rowData.log_date * 1000).getUTCFullYear(),
        new Date(props.rowData.log_date * 1000).getUTCMonth(),
        new Date(props.rowData.log_date * 1000).getUTCDate(),
        selectedTime.getUTCHours(),
        selectedTime.getUTCMinutes(),
        0 // Always set seconds to 00
      )
    );

    const combinedEpoch = combineDateWithTime(
      props.rowData.log_date,
      utcSelectedTime
    );

    props.setAddTrackerTimeData((prev: any) => ({
      ...prev,
      tracker_end: combinedEpoch,
    }));

    const currentStartTimeEpoch =
      props.addTrackerTimeData.tracker_start || props.rowData.tracker_punch_in;

    if (currentStartTimeEpoch && combinedEpoch) {
      const duration = calculateDuration(currentStartTimeEpoch, combinedEpoch);
      props.setAddTrackerTimeData((prev: any) => ({
        ...prev,
        tracker_duration: duration,
      }));
    }
  };

  return (
    <div className="tw-flex tw-align-items-center tw-gap-2 tw-w-full">
      {/* Tracker Start */}
      <span className="tw-flex tw-gap-2">
        {isEdit ? (
          <Calendar
            value={
              props.addTrackerTimeData.tracker_start
                ? new Date(props.addTrackerTimeData.tracker_start * 1000)
                : props.rowData.tracker_punch_in
                ? new Date(props.rowData.tracker_punch_in * 1000)
                : null
            }
            onChange={(e) => {
              if (e.value) {
                handleTrackerStartChange(e);
              }
            }}
            timeOnly
            hourFormat="24"
            className="tw-border tw-border-solid tw-border-[#E2E2E2] tw-px-2 tw-py-[3px] tw-rounded tw-text-sm tw-w-[60px] tw-pl-[10px]"
          />
        ) : (
          <span
            className={`tw-px-2 tw-py-1 tw-rounded tw-text-sm tw-min-w-12  ${
              props.rowData.tracker_punch_out
                ? "tw-border tw-border-gray-300"
                : "tw-w-[60px]"
            }`}
          >
            {props.rowData.tracker_punch_in &&
              convertEpochToTime(props.rowData.tracker_punch_in)}
          </span>
        )}
      </span>

      {/* Tracker End */}
      <span className="tw-flex tw-gap-2">
        {isEdit ? (
          <Calendar
            value={
              props.addTrackerTimeData.tracker_end
                ? new Date(props.addTrackerTimeData.tracker_end * 1000)
                : props.rowData.tracker_punch_out
                ? new Date(props.rowData.tracker_punch_out * 1000)
                : null
            }
            onChange={handleTrackerEndChange}
            timeOnly
            hourFormat="24"
            className="tw-border tw-border-solid tw-border-[#E2E2E2] tw-px-2 tw-py-[3px] tw-rounded tw-text-sm tw-w-[60px] tw-pl-[10px]"
          />
        ) : (
          <span
            className={`tw-px-2 tw-py-1 tw-rounded tw-text-sm tw-min-w-12 ${
              props.rowData.tracker_punch_out
                ? "tw-border tw-border-gray-300"
                : "tw-w-[60px]"
            }`}
          >
            {props.rowData.tracker_punch_out &&
              convertEpochToTime(props.rowData.tracker_punch_out)}
          </span>
        )}
      </span>

      {/* Tracker Duration */}
      <span className="tw-flex tw-gap-2">
        {isEdit ? (
          <InputText
            value={
              props.addTrackerTimeData.tracker_duration
                ? removeSecFromDuration(
                    props.addTrackerTimeData.tracker_duration
                  )
                : props.rowData.tracker_duration
                ? removeSecFromDuration(props.rowData.tracker_duration)
                : "00:00"
            }
            className="tw-border tw-border-solid tw-border-[#E2E2E2] tw-px-2 tw-py-[3px] tw-rounded tw-text-sm tw-w-[60px] tw-pl-[10px]"
            readOnly // Make the input read-only since it's auto-calculated
          />
        ) : (
          <span className="tw-text-[#00AFEE] tw-font-medium tw-text-sm tw-flex tw-items-center tw-w-auto">
            {removeSecFromDuration(props.rowData.tracker_duration)}{" "}
            {props.rowData.tracker_duration && "hrs"}
          </span>
        )}
      </span>

      {/* Edit Button */}
      {props.type === "teamLogs" &&
        (localStorage.roleName.includes(ROLES.TIMELOG_ADMIN) ||
          localStorage.roleName.includes(ROLES.TIMELOG_HR)) &&
        props.rowData.status !== TIMELOG_STATUSES.APPROVED &&
        props.rowData.status !== TIMELOG_STATUSES.REJECTED && (
          <Button
            icon={isEdit ? "pi pi-check" : "pi pi-pencil"}
            className="tw-bg-white tw-border-0 tw-border-solid tw-border-transparent tw-px-1 focus:tw-shadow-none"
            onClick={() => {
              if (isEdit && props.addTrackerTimeData.tracker_duration) {
                const effectiveStartTime =
                  props.addTrackerTimeData.tracker_start ||
                  props.rowData.tracker_punch_in;
                const effectiveEndTime =
                  props.addTrackerTimeData.tracker_end ||
                  props.rowData.tracker_punch_out;

                if (!effectiveStartTime || !effectiveEndTime) {
                  props.setAddTrackerTimeData({
                    timeLogID: null,
                    tracker_start: null,
                    tracker_end: null,
                    tracker_duration: null,
                    admin_comment: null,
                    isLogTimeMisMatch: false,
                  });
                  showError(
                    "Please select a valid start and end tracker time.",
                    props.toast
                  );
                  return;
                }

                const payload = {
                  ...props.addTrackerTimeData,
                };

                if (!payload.tracker_start && props.rowData.tracker_punch_in) {
                  payload.tracker_start = props.rowData.tracker_punch_in;
                }
                if (!payload.tracker_end && props.rowData.tracker_punch_out) {
                  payload.tracker_end = props.rowData.tracker_punch_out;
                }

                addTrackerTime(
                  payload,
                  props.rowData.timeLogID,
                  props.toast,
                  props.setTeamLogsDataLoading,
                  props.setEditTrackerTimeRowIndex,
                  props.rowData,
                  false,
                  false,
                  "addTrackerTime"
                ).then(() => {
                  fetchTeamLogsData({
                    sortFilter: props.sortFilter,
                    setTeamLogsData: props.setTeamLogsData,
                    setTeamLogsDataLoading: props.setTeamLogsDataLoading,
                    filters: props.filters.endDate && props.filters,
                    toast: props.toast,
                    isWorkerView: props.isWorkerView,
                    setExpandedRows: props.setExpandedRows,
                    setIsExportDisabled: props.setIsExportDisabled,
                  });
                });
              } else {
                props.setAddTrackerTimeData({
                  timeLogID: null,
                  tracker_start: null,
                  tracker_end: null,
                  tracker_duration: null,
                  admin_comment: null,
                  isLogTimeMisMatch: false,
                });
              }
              handleEditClick(props.rowData.timeLogID);
            }}
          />
        )}

      {/* Additional Icon */}
      <span
        className="tw-cursor-pointer tw-px-0 tw-py-1 tw-rounded"
        onClick={() => {
          props.setSelectedRowData(props.rowData);
          props.setVisible(true);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
        >
          <path
            opacity="0.2"
            d="M17.7666 9.99999C17.7668 11.3171 17.4201 12.6111 16.7614 13.7517C16.1027 14.8923 15.1552 15.8393 14.0143 16.4975C12.8734 17.1556 11.5792 17.5017 10.2621 17.5009C8.94496 17.5001 7.65126 17.1525 6.51113 16.493L3.59004 17.4672C3.47992 17.5039 3.36174 17.5092 3.24876 17.4826C3.13578 17.4559 3.03246 17.3983 2.95037 17.3162C2.86829 17.2341 2.81069 17.1308 2.78402 17.0178C2.75736 16.9049 2.76269 16.7867 2.79941 16.6766L3.77363 13.7555C3.19778 12.7594 2.8588 11.6442 2.78293 10.4962C2.70706 9.3482 2.89632 8.19811 3.33608 7.13494C3.77583 6.07178 4.4543 5.12404 5.31897 4.36505C6.18363 3.60607 7.21133 3.05619 8.32253 2.75796C9.43373 2.45973 10.5987 2.42115 11.7272 2.64521C12.8556 2.86926 13.9175 3.34994 14.8305 4.05005C15.7435 4.75016 16.4831 5.65094 16.9923 6.68268C17.5014 7.71442 17.7664 8.84947 17.7666 9.99999Z"
            fill="black"
          />
          <path
            d="M10.2667 1.875C8.8639 1.87469 7.48496 2.23757 6.26405 2.9283C5.04314 3.61904 4.02186 4.6141 3.29961 5.81664C2.57737 7.01918 2.17876 8.38822 2.14259 9.79052C2.10643 11.1928 2.43393 12.5806 3.09323 13.8188L2.20651 16.4789C2.13306 16.6992 2.1224 16.9355 2.17573 17.1615C2.22905 17.3874 2.34426 17.5941 2.50842 17.7582C2.67259 17.9224 2.87924 18.0376 3.1052 18.0909C3.33117 18.1443 3.56751 18.1336 3.78776 18.0602L6.44792 17.1734C7.53758 17.753 8.74496 18.0767 9.97841 18.12C11.2119 18.1633 12.439 17.925 13.5666 17.4232C14.6942 16.9215 15.6926 16.1694 16.4862 15.2241C17.2798 14.2789 17.8475 13.1652 18.1465 11.9678C18.4454 10.7703 18.4675 9.52047 18.2113 8.31315C17.9551 7.10584 17.4271 5.97276 16.6676 4.99993C15.9081 4.02711 14.9369 3.24009 13.8278 2.69864C12.7187 2.15718 11.5009 1.87551 10.2667 1.875ZM10.2667 16.875C9.05805 16.8758 7.87065 16.5575 6.82448 15.9523C6.72953 15.8973 6.62175 15.8682 6.51198 15.868C6.44474 15.868 6.37796 15.8791 6.31432 15.9008L3.39167 16.875L4.36588 13.9531C4.39397 13.8692 4.40389 13.7802 4.395 13.6921C4.38611 13.604 4.35861 13.5188 4.31432 13.4422C3.55649 12.132 3.25222 10.6083 3.44872 9.10747C3.64522 7.60667 4.3315 6.21267 5.40111 5.14171C6.47071 4.07076 7.86385 3.38271 9.3644 3.18431C10.8649 2.98592 12.389 3.28826 13.7002 4.04444C15.0114 4.80062 16.0364 5.96837 16.6162 7.36652C17.196 8.76468 17.2981 10.3151 16.9068 11.7773C16.5156 13.2394 15.6527 14.5316 14.4521 15.4533C13.2515 16.375 11.7803 16.8748 10.2667 16.875ZM11.2042 10C11.2042 10.1854 11.1492 10.3667 11.0462 10.5208C10.9432 10.675 10.7967 10.7952 10.6254 10.8661C10.4541 10.9371 10.2656 10.9557 10.0838 10.9195C9.90191 10.8833 9.73486 10.794 9.60375 10.6629C9.47264 10.5318 9.38335 10.3648 9.34718 10.1829C9.31101 10.001 9.32957 9.81254 9.40053 9.64123C9.47149 9.46993 9.59165 9.32351 9.74582 9.2205C9.89999 9.11748 10.0812 9.0625 10.2667 9.0625C10.5153 9.0625 10.7538 9.16127 10.9296 9.33709C11.1054 9.5129 11.2042 9.75136 11.2042 10ZM7.76667 10C7.76667 10.1854 7.71168 10.3667 7.60867 10.5208C7.50565 10.675 7.35924 10.7952 7.18793 10.8661C7.01663 10.9371 6.82813 10.9557 6.64627 10.9195C6.46441 10.8833 6.29736 10.794 6.16625 10.6629C6.03514 10.5318 5.94585 10.3648 5.90968 10.1829C5.87351 10.001 5.89207 9.81254 5.96303 9.64123C6.03399 9.46993 6.15415 9.32351 6.30832 9.2205C6.46249 9.11748 6.64375 9.0625 6.82917 9.0625C7.07781 9.0625 7.31626 9.16127 7.49208 9.33709C7.66789 9.5129 7.76667 9.75136 7.76667 10ZM14.6417 10C14.6417 10.1854 14.5867 10.3667 14.4837 10.5208C14.3807 10.675 14.2342 10.7952 14.0629 10.8661C13.8916 10.9371 13.7031 10.9557 13.5213 10.9195C13.3394 10.8833 13.1724 10.794 13.0413 10.6629C12.9101 10.5318 12.8209 10.3648 12.7847 10.1829C12.7485 10.001 12.7671 9.81254 12.838 9.64123C12.909 9.46993 13.0291 9.32351 13.1833 9.2205C13.3375 9.11748 13.5187 9.0625 13.7042 9.0625C13.9528 9.0625 14.1913 9.16127 14.3671 9.33709C14.5429 9.5129 14.6417 9.75136 14.6417 10Z"
            fill="black"
          />
        </svg>
      </span>

      {/* History Icons */}
      <span
        className="tw-cursor-pointer tw-px-0 tw-pt-[7px] tw-rounded"
        onClick={() => {
          props.setSelectedRowData(props.rowData);
          props.setTimelogActivity(
            JSON.parse(props?.rowData?.timelogHistoryDetails)
          );
          props.setViewHistoryPopup(true);
        }}
      >
        <svg
          width="13"
          height="16"
          viewBox="0 0 13 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.375 9.6875H11.625C11.9234 9.6875 12.2095 9.56897 12.4205 9.358C12.6315 9.14702 12.75 8.86087 12.75 8.5625V6.3125C12.75 6.01413 12.6315 5.72798 12.4205 5.517C12.2095 5.30603 11.9234 5.1875 11.625 5.1875H9.375C9.07663 5.1875 8.79048 5.30603 8.5795 5.517C8.36853 5.72798 8.25 6.01413 8.25 6.3125V6.875H3.1875V4.625H3.75C4.04837 4.625 4.33452 4.50647 4.5455 4.2955C4.75647 4.08452 4.875 3.79837 4.875 3.5V1.25C4.875 0.951631 4.75647 0.665483 4.5455 0.454505C4.33452 0.243526 4.04837 0.125 3.75 0.125H1.5C1.20163 0.125 0.915483 0.243526 0.704505 0.454505C0.493526 0.665483 0.375 0.951631 0.375 1.25V3.5C0.375 3.79837 0.493526 4.08452 0.704505 4.2955C0.915483 4.50647 1.20163 4.625 1.5 4.625H2.0625V12.5C2.0625 12.9476 2.24029 13.3768 2.55676 13.6932C2.87322 14.0097 3.30245 14.1875 3.75 14.1875H8.25V14.75C8.25 15.0484 8.36853 15.3345 8.5795 15.5455C8.79048 15.7565 9.07663 15.875 9.375 15.875H11.625C11.9234 15.875 12.2095 15.7565 12.4205 15.5455C12.6315 15.3345 12.75 15.0484 12.75 14.75V12.5C12.75 12.2016 12.6315 11.9155 12.4205 11.7045C12.2095 11.4935 11.9234 11.375 11.625 11.375H9.375C9.07663 11.375 8.79048 11.4935 8.5795 11.7045C8.36853 11.9155 8.25 12.2016 8.25 12.5V13.0625H3.75C3.60082 13.0625 3.45774 13.0032 3.35225 12.8977C3.24676 12.7923 3.1875 12.6492 3.1875 12.5V8H8.25V8.5625C8.25 8.86087 8.36853 9.14702 8.5795 9.358C8.79048 9.56897 9.07663 9.6875 9.375 9.6875ZM1.5 1.25H3.75V3.5H1.5V1.25ZM9.375 12.5H11.625V14.75H9.375V12.5ZM9.375 6.3125H11.625V8.5625H9.375V6.3125Z"
            fill="#007AFF"
          />
        </svg>
      </span>
    </div>
  );
};

export const statusBodyTemplate = (
  rowData: any,
  setShowTimeLogDetails: any,
  setTimeLogDetails: any,
  setIsManagerRejectView: any,
  setIsManagerApproveView: any,
  setSelectedRowData: any,
  sortFilter: any,
  setTeamLogsData: any,
  setTeamLogsDataLoading: any,
  filters: any,
  isWorkerView: any,
  setExpandedRows: any,
  setIsExportDisabled: any,
  setIsHRApproving: any,
  toast: any,
  setShowApprovePopup?: any,
  setShowRejectPopup?: any
) => {
  return (
    <div className="tw-flex tw-gap-2 tw-items-center">
      <span className="a-badge tw-border-transparent">
        {/* <span
          className={`dot ${
            rowData.status === "PENDING"
              ? "tw-bg-yellow-500"
              : rowData.status === "SUBMITTED"
              ? "tw-bg-[#007AFF]"
              : "bg-success"
          }`}
        ></span> */}
        <span
          className={`dot ${
            rowData.status === "APPROVED"
              ? "bg-success"
              : rowData.status === "SUBMITTED TO MANAGER"
              ? "tw-bg-[#0255b0]"
              : rowData.status === "PENDING"
              ? "tw-bg-yellow-500"
              : rowData.status === "SUBMITTED"
              ? "tw-bg-[#25ccdb]"
              : rowData.status === "APPROVED BY MANAGER"
              ? "tw-bg-[#9e1c7f]"
              : rowData.status === "REJECTED"
              ? "tw-bg-red-500"
              : rowData.status === "REJECTED BY MANAGER"
              ? "tw-bg-red-500"
              : "tw-bg-black"
          }`}
        ></span>
        <span className="badge-value tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
          {rowData.status}
        </span>
      </span>
      {((rowData.lineManagerID.toString() === localStorage.userID.toString() &&
        rowData.status === "SUBMITTED TO MANAGER") ||
        ((localStorage.roleName.includes(ROLES.TIMELOG_ADMIN) ||
          localStorage.roleName.includes(ROLES.TIMELOG_HR)) &&
          (rowData.status === "APPROVED BY MANAGER" ||
            rowData.status === "REJECTED BY MANAGER" ||
            rowData.status === "SUBMITTED"))) &&
        rowData.tracker_duration && (
          <div className="tw-flex tw-gap-2 tw-justify-end">
            <span
              onClick={() => {
                if (
                  rowData.status === "APPROVED BY MANAGER" ||
                  rowData.status === "REJECTED BY MANAGER" ||
                  rowData.status === "SUBMITTED"
                ) {
                  // HR Approve - Show popup
                  setSelectedRowData(rowData);
                  if (setShowApprovePopup) {
                    setShowApprovePopup(true);
                  }
                } else {
                  // Manager Approve - Show comment dialog
                  setSelectedRowData(rowData);
                  setIsManagerApproveView(true);
                }
              }}
              className="tw-cursor-pointer"
            >
              <ApproveTimeLogIconSVG />
            </span>
            {((rowData.lineManagerID.toString() ===
              localStorage.userID.toString() &&
              rowData.status === "SUBMITTED TO MANAGER") ||
              ((localStorage.roleName.includes(ROLES.TIMELOG_ADMIN) ||
                localStorage.roleName.includes(ROLES.TIMELOG_HR)) &&
                (rowData.status === "APPROVED BY MANAGER" ||
                  rowData.status === "REJECTED BY MANAGER"))) && (
              <span
                onClick={() => {
                  setSelectedRowData(rowData);
                  if (
                    rowData.status === "APPROVED BY MANAGER" ||
                    rowData.status === "REJECTED BY MANAGER"
                  ) {
                    // HR Reject - Show popup
                    if (setShowRejectPopup) {
                      setShowRejectPopup(true);
                    }
                  } else {
                    // Manager Reject - Show timelog details
                    setIsManagerRejectView(true);
                    setTimeLogDetails(rowData.timelogdetails);
                    setShowTimeLogDetails(true);
                  }
                }}
                className="tw-cursor-pointer"
              >
                <RejectTimeLogIconSVG />
              </span>
            )}
          </div>
        )}
    </div>
  );
};

export const vehicleRegistrationTemplate = (
  rowData: any,
  vehiclesList: any,
  vehicleListLoading: boolean,
  editVehicleRowIndex: any,
  setEditVehicleRowIndex: any,
  selectedVehicle: any,
  setSelectedVehicle: any,
  selectedVehicleRegistrationNo: any,
  setSelectedVehicleRegistrationNo: any
) => {
  const isEdit = editVehicleRowIndex === rowData.timeLogID;
  const handleEditClick = (timeLogID: any) => {
    if (isEdit) {
      setEditVehicleRowIndex(null); // Close current row
    } else if (editVehicleRowIndex === null) {
      setEditVehicleRowIndex(timeLogID); // Open only if no other row is being edited
    }
  };

  return (
    <div className="tw-flex tw-items-center tw-gap-3">
      {!isEdit && <span>{rowData.registration_no}</span>}
      {isEdit ? (
        <>
          <Dropdown
            value={selectedVehicleRegistrationNo}
            onChange={(e) => {
              setSelectedVehicle({
                timeLogID: rowData.timeLogID,
                log_date: rowData.log_date,
                vehicleID: e.value.vehicleID,
                userID: rowData.userID,
              });
              setSelectedVehicleRegistrationNo(e.value);
            }}
            options={vehiclesList}
            optionLabel="registration_no"
            placeholder="Select Vehicle"
            loading={vehicleListLoading}
            filter
            className="small-dropdown tw-border tw-border-solid tw-py-0 tw-border-[#D0D5DD]"
          />
          <Button
            icon="pi pi-times"
            className="tw-bg-white tw-border-0 tw-border-solid tw-border-transparent tw-px-1 focus:tw-shadow-none"
            onClick={() => handleEditClick(rowData.timeLogID)}
          />
        </>
      ) : rowData.lineManagerID.toString() === localStorage.userID.toString() &&
        rowData.status === TIMELOG_STATUSES.SUBMITTED_TO_MANAGER ? (
        <Button
          type="button"
          icon="pi pi-pencil"
          className="tw-bg-white tw-border-0 tw-border-solid tw-border-transparent tw-px-1 focus:tw-shadow-none"
          onClick={() => handleEditClick(rowData.timeLogID)}
        />
      ) : null}
    </div>
  );
};

export const projectNameBodyTemplate = (props: any) => {
  const optionsTemplate = (option: any) => {
    return (
      <span className="tw-text-sm tw-text-[#64748B] tw-font-bold tw-leading-4 ">
        {option.projectName} - {`( ${option.projectKey} )`}
      </span>
    );
  };
  // Find the previously selected project for this row
  const selectedProjectForRow = props.selectedProjectArray.find(
    (selectedProject: any) =>
      selectedProject.timelogdetailsID === props.rowData.timelogdetailsID
  );

  // Get the full project object from projectsList
  const currentProject = props.projectsList.find(
    (project: any) =>
      project.projectID ===
      (selectedProjectForRow?.projectID || props.rowData.projectID)
  );

  const projectsOptionTemplate = (option: any) => {
    return (
      <div>
        <span className="tw-text-base tw-ttw-font- tw-leading-4 tw-w-auto">
          {option.name} - {`( ${option.projectKey} )`}
        </span>
      </div>
    );
  };

  return (
    <>
      {props.editProjectIndices.includes(props.rowData.timelogdetailsID) ? (
        <Dropdown
          value={currentProject}
          onChange={(e) => {
            props.setSelectedProject(e.value);
            const existingProjectIndex = props.selectedProjectArray.findIndex(
              (selectedProject: any) =>
                selectedProject.timelogdetailsID ===
                props.rowData.timelogdetailsID
            );
            if (existingProjectIndex > -1) {
              props.selectedProjectArray[existingProjectIndex] = {
                timeLogID: props.rowData.timeLogID,
                timelogdetailsID: props.rowData.timelogdetailsID,
                projectID: e.value.projectID,
              };
            } else {
              props.selectedProjectArray.push({
                timeLogID: props.rowData.timeLogID,
                timelogdetailsID: props.rowData.timelogdetailsID,
                projectID: e.value.projectID,
              });
            }
          }}
          options={props.projectsList}
          optionLabel="name"
          itemTemplate={projectsOptionTemplate}
          optionGroupTemplate={optionsTemplate}
          placeholder="Select Project"
          loading={props.projectsListLoading}
          filter
          filterBy="name,projectKey"
          style={{ width: "300px" }}
          className="small-dropdown tw-border tw-border-solid tw-py-0 tw-border-[#D0D5DD] "
        />
      ) : (
        <span className="tw-text-sm tw-text-[#64748B] tw-font-medium tw-leading-4 tw-w-[340px] tw-max-w-[340px] tw-min-w-[340px] tw-text-wrap">
          {props.rowData.projectName} - {`( ${props.rowData.projectKey} )`}
        </span>
      )}
    </>
  );
};

export const appTimeLogBodyTemplate = (props: any) => {
  const isEdit = props.editAppTimeRowIndices.includes(
    props.rowData.timelogdetailsID
  );

  // Function to combine date from log_date with selected time
  const combineDateWithTime = (
    logDateEpoch: number,
    selectedTime: Date | string | null
  ) => {
    // Ensure logDateEpoch is in seconds
    const logDateInSeconds = logDateEpoch;
    const logDate = new Date(logDateInSeconds * 1000); // Convert log_date to a Date object

    // Handle different input types for selectedTime
    let timeHours = 0;
    let timeMinutes = 0;
    let timeSeconds = 0;

    if (selectedTime instanceof Date) {
      // If it's a Date object from Calendar selection
      timeHours = selectedTime.getHours();
      timeMinutes = selectedTime.getMinutes();
      timeSeconds = selectedTime.getSeconds();
    } else if (typeof selectedTime === "string") {
      // If it's a string from manual input (assuming format like "HH:MM" or "HH:MM:SS")
      const timeParts = selectedTime.split(":");
      timeHours = parseInt(timeParts[0], 10) || 0;
      timeMinutes = parseInt(timeParts[1], 10) || 0;
      timeSeconds = parseInt(timeParts[2], 10) || 0;
    } else if (selectedTime === null) {
      // If null is passed, use midnight
      return null;
    }

    const combinedDate = new Date(
      logDate.getFullYear(),
      logDate.getMonth(),
      logDate.getDate(),
      timeHours,
      timeMinutes,
      timeSeconds
    );

    const epochTime = Math.floor(combinedDate.getTime() / 1000); // Convert to epoch time (seconds)

    return epochTime;
  };

  // Function to calculate duration in HH:MM:SS format
  const calculateDuration = (startTimeEpoch: number, endTimeEpoch: number) => {
    if (!startTimeEpoch || !endTimeEpoch) return "00:00";

    const startTime = new Date(startTimeEpoch * 1000);
    const endTime = new Date(endTimeEpoch * 1000);

    // Clone endTime to potentially adjust for next day calculation
    let adjustedEndTime = new Date(endTime);

    // Check if end time is earlier than start time (implying next day)
    const startHours = startTime.getHours();
    const startMinutes = startTime.getMinutes();
    const startSeconds = startTime.getSeconds();
    const endHours = endTime.getHours();
    const endMinutes = endTime.getMinutes();
    const endSeconds = endTime.getSeconds();

    // Calculate total seconds for both times
    const startTotalSeconds =
      startHours * 3600 + startMinutes * 60 + startSeconds;
    const endTotalSeconds = endHours * 3600 + endMinutes * 60 + endSeconds;

    // If end time appears earlier, add a day to the end time
    if (endTotalSeconds < startTotalSeconds) {
      adjustedEndTime.setDate(adjustedEndTime.getDate() + 1);
    }

    const timeDifferenceMs = adjustedEndTime.getTime() - startTime.getTime();
    const totalSeconds = Math.floor(timeDifferenceMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}`;
  };

  // Handler for app start time change
  const handleAppStartChange = (e: any) => {
    // Handle both Calendar selection and manual input
    const selectedTime = e.value;

    if (!selectedTime && typeof e.target?.value === "string") {
      // Handle manual text input case
      handleManualTimeInput(e.target.value, "start_time");
      return;
    }

    // Rest of your existing code for Calendar selection
    const currentTimelogdetailsID = props.rowData.timelogdetailsID;
    const currentUserID = props.rowData.userID;
    const currentProjectID = props.rowData.projectID;

    // Get current data for this specific row, if it exists
    const existingRowData = props.selectedAppTimeDataArray.find(
      (item: any) => item.timelogdetailsID === currentTimelogdetailsID
    ) || {
      start_time: props.rowData.start_time,
      end_time: props.rowData.end_time,
      duration: props.rowData.duration,
      timelogdetailsID: currentTimelogdetailsID,
      userID: currentUserID,
      projectID: currentProjectID,
      timeLogID: props.rowData.timeLogID,
    };

    // Ensure log_date is in seconds
    const logDateInSeconds =
      typeof props.rowData.log_date === "number" &&
      props.rowData.log_date > 10000000000
        ? props.rowData.log_date / 1000 // Convert from milliseconds to seconds if needed
        : props.rowData.log_date;

    // Get the epoch time for the selected start time
    const combinedEpoch = combineDateWithTime(logDateInSeconds, selectedTime);

    if (!combinedEpoch) return; // Exit if invalid time

    // Create updated data for this specific row
    const updatedData = {
      ...existingRowData,
      start_time: combinedEpoch,
    };

    // Recalculate duration if end_time is set
    if (updatedData.end_time) {
      updatedData.duration = calculateDuration(
        combinedEpoch,
        updatedData.end_time
      );
    }

    // Update the selectedAppTimeDataArray
    const existingIndex = props.selectedAppTimeDataArray.findIndex(
      (item: any) => item.timelogdetailsID === currentTimelogdetailsID
    );

    if (existingIndex > -1) {
      // Update existing record
      const updatedArray = [...props.selectedAppTimeDataArray];
      updatedArray[existingIndex] = updatedData;
      props.setSelectedAppTimeDataArray(updatedArray);
    } else {
      // Add new record
      props.setSelectedAppTimeDataArray([
        ...props.selectedAppTimeDataArray,
        updatedData,
      ]);
    }
  };

  // Handler for app end time change
  const handleAppEndChange = (e: any) => {
    // Handle both Calendar selection and manual input
    const selectedTime = e.value;

    if (!selectedTime && typeof e.target?.value === "string") {
      // Handle manual text input case
      handleManualTimeInput(e.target.value, "end_time");
      return;
    }

    // Rest of your existing code for Calendar selection
    const currentTimelogdetailsID = props.rowData.timelogdetailsID;
    const currentUserID = props.rowData.userID;
    const currentProjectID = props.rowData.projectID;

    // Get current data for this specific row, if it exists
    const existingRowData = props.selectedAppTimeDataArray.find(
      (item: any) => item.timelogdetailsID === currentTimelogdetailsID
    ) || {
      start_time: props.rowData.start_time,
      end_time: props.rowData.end_time,
      duration: props.rowData.duration,
      userID: currentUserID,
      projectID: currentProjectID,
      timelogdetailsID: currentTimelogdetailsID,
      timeLogID: props.rowData.timeLogID,
    };

    // Ensure log_date is in seconds
    const logDateInSeconds =
      typeof props.rowData.log_date === "number" &&
      props.rowData.log_date > 10000000000
        ? props.rowData.log_date / 1000 // Convert from milliseconds to seconds if needed
        : props.rowData.log_date;

    // Get the epoch time for the selected end time
    const combinedEpoch = combineDateWithTime(logDateInSeconds, selectedTime);

    if (!combinedEpoch) return; // Exit if invalid time

    // Create updated data for this specific row
    const updatedData = {
      ...existingRowData,
      end_time: combinedEpoch,
    };

    // Recalculate duration if start_time is set
    if (updatedData.start_time) {
      updatedData.duration = calculateDuration(
        updatedData.start_time,
        combinedEpoch
      );
    }

    // Update the selectedAppTimeDataArray
    const existingIndex = props.selectedAppTimeDataArray.findIndex(
      (item: any) => item.timelogdetailsID === currentTimelogdetailsID
    );

    if (existingIndex > -1) {
      // Update existing record
      const updatedArray = [...props.selectedAppTimeDataArray];
      updatedArray[existingIndex] = updatedData;
      props.setSelectedAppTimeDataArray(updatedArray);
    } else {
      // Add new record
      props.setSelectedAppTimeDataArray([
        ...props.selectedAppTimeDataArray,
        updatedData,
      ]);
    }
  };

  // New function to handle manual time input
  const handleManualTimeInput = (
    timeString: string,
    timeType: "start_time" | "end_time"
  ) => {
    // Validate time string (basic validation)
    if (!timeString.match(/^([01]?[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/)) {
      // Invalid time format
      return;
    }

    const currentTimelogdetailsID = props.rowData.timelogdetailsID;
    const currentUserID = props.rowData.userID;
    const currentProjectID = props.rowData.projectID;

    // Get current data for this specific row
    const existingRowData = props.selectedAppTimeDataArray.find(
      (item: any) => item.timelogdetailsID === currentTimelogdetailsID
    ) || {
      start_time: props.rowData.start_time,
      end_time: props.rowData.end_time,
      duration: props.rowData.duration,
      timelogdetailsID: currentTimelogdetailsID,
      userID: currentUserID,
      projectID: currentProjectID,
      timeLogID: props.rowData.timeLogID,
    };

    // Ensure log_date is in seconds
    const logDateInSeconds =
      typeof props.rowData.log_date === "number" &&
      props.rowData.log_date > 10000000000
        ? props.rowData.log_date / 1000
        : props.rowData.log_date;

    // Parse the time string to create time components
    const [hours, minutes, seconds = "0"] = timeString
      .split(":")
      .map((num) => parseInt(num, 10));

    // Create a temporary date object with the current time
    const tempDate = new Date();
    tempDate.setHours(
      hours,
      minutes,
      typeof seconds === "string" ? parseInt(seconds, 10) : seconds
    );

    // Get the epoch time
    const combinedEpoch = combineDateWithTime(logDateInSeconds, tempDate);

    if (!combinedEpoch) return; // Exit if invalid time

    // Create updated data
    const updatedData = {
      ...existingRowData,
      [timeType]: combinedEpoch,
    };

    // Recalculate duration if both start and end times are set
    if (updatedData.start_time && updatedData.end_time) {
      updatedData.duration = calculateDuration(
        updatedData.start_time,
        updatedData.end_time
      );
    }

    // Update the data array
    const existingIndex = props.selectedAppTimeDataArray.findIndex(
      (item: any) => item.timelogdetailsID === currentTimelogdetailsID
    );

    if (existingIndex > -1) {
      const updatedArray = [...props.selectedAppTimeDataArray];
      updatedArray[existingIndex] = updatedData;
      props.setSelectedAppTimeDataArray(updatedArray);
    } else {
      props.setSelectedAppTimeDataArray([
        ...props.selectedAppTimeDataArray,
        updatedData,
      ]);
    }
  };

  // Find the current row's data in the selectedAppTimeDataArray
  const currentRowData = props.selectedAppTimeDataArray.find(
    (item: any) => item.timelogdetailsID === props.rowData.timelogdetailsID
  );

  return (
    <>
      {/* {props.isManagerRejectView ? (
        <div className="tw-flex tw-align-items-center tw-gap-2 tw-w-full tw-max-w-[320px] tw-min-w-[320px]">
          <div className="tw-flex tw-flex-col tw-items-start">
            <span className="tw-flex tw-gap-2">
              {isEdit ? (
                <Calendar
                  value={
                    currentRowData?.start_time
                      ? new Date(currentRowData.start_time * 1000)
                      : props.rowData.start_time
                      ? new Date(props.rowData.start_time * 1000)
                      : null
                  }
                  onChange={handleAppStartChange}
                  timeOnly
                  hourFormat="24"
                  className="tw-border tw-border-solid tw-border-[#E2E2E2] tw-px-2 tw-py-[3px] tw-rounded tw-text-sm tw-w-14 tw-pl-[10px] tw-ml-[12px] tw-mr-[36px]"
                />
              ) : (
                <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4 tw-ml-[12px] tw-mr-5">
                  {props.rowData.start_time &&
                    convertEpochToTime(props.rowData.start_time)}
                </span>
              )}
            </span>
            <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4 tw-ml-[12px]">
              Start Time
            </span>
          </div>

          <div className="tw-flex tw-flex-col tw-items-start">
            <span className="tw-flex tw-gap-2">
              {isEdit ? (
                <Calendar
                  value={
                    currentRowData?.end_time
                      ? new Date(currentRowData.end_time * 1000)
                      : props.rowData.end_time
                      ? new Date(props.rowData.end_time * 1000)
                      : null
                  }
                  onChange={handleAppEndChange}
                  timeOnly
                  hourFormat="24"
                  className="tw-border tw-border-solid tw-border-[#E2E2E2] tw-px-2 tw-py-[3px] tw-rounded tw-text-sm tw-w-14 tw-pl-[10px] tw-mr-[36px]"
                />
              ) : (
                <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4 tw-mr-5">
                  {props.rowData.end_time &&
                    convertEpochToTime(props.rowData.end_time)}
                </span>
              )}
            </span>
            <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
              End Time
            </span>
          </div>

          <div className="tw-flex tw-flex-col tw-items-start">
            <span className="tw-flex tw-gap-2">
              {isEdit ? (
                <InputText
                  value={
                    currentRowData?.duration ??
                    props.rowData.duration ??
                    "00:00"
                  }
                  className="tw-border tw-border-solid tw-border-[#E2E2E2] tw-px-2 tw-py-[3px] tw-rounded tw-text-sm tw-w-14 tw-pl-[10px]"
                  readOnly
                />
              ) : (
                <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4">
                  {props.rowData.duration}
                </span>
              )}
            </span>
            <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
              Total Hours
            </span>
          </div>
        </div>
      ) : ( */}
      <div className="tw-grid tw-grid-cols-3 tw-gap-3 tw-max-w-[320px] tw-min-w-[320px]">
        <div className="tw-flex tw-flex-col tw-items-start">
          <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4">
            {props.rowData.start_time &&
              convertEpochToTime(props.rowData.start_time)}
          </span>
          <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
            Start Time
          </span>
        </div>
        <div className="tw-flex tw-flex-col tw-items-start">
          <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4">
            {props.rowData.end_time &&
              convertEpochToTime(props.rowData.end_time)}
          </span>
          <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
            End Time
          </span>
        </div>
        <div className="tw-flex tw-flex-col tw-items-start">
          <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4">
            {props.rowData.duration &&
              removeSecFromDuration(props.rowData.duration)}
          </span>
          <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
            Total Hours
          </span>
        </div>
      </div>
      {/* )} */}
    </>
  );
};

export const managerTimeBodyTemplate = (props: any) => {
  // const isEdit = props.editAppTimeRowIndices.includes(
  //   props.rowData.timelogdetailsID
  // );

  // // Function to combine date from log_date with selected time
  // const combineDateWithTime = (
  //   logDateEpoch: number,
  //   selectedTime: Date | string | null
  // ) => {
  //   // Ensure logDateEpoch is in seconds
  //   const logDateInSeconds = logDateEpoch;
  //   const logDate = new Date(logDateInSeconds * 1000); // Convert log_date to a Date object

  //   // Handle different input types for selectedTime
  //   let timeHours = 0;
  //   let timeMinutes = 0;
  //   let timeSeconds = 0;

  //   if (selectedTime instanceof Date) {
  //     // If it's a Date object from Calendar selection
  //     timeHours = selectedTime.getHours();
  //     timeMinutes = selectedTime.getMinutes();
  //     timeSeconds = selectedTime.getSeconds();
  //   } else if (typeof selectedTime === "string") {
  //     // If it's a string from manual input (assuming format like "HH:MM" or "HH:MM:SS")
  //     const timeParts = selectedTime.split(":");
  //     timeHours = parseInt(timeParts[0], 10) || 0;
  //     timeMinutes = parseInt(timeParts[1], 10) || 0;
  //     timeSeconds = parseInt(timeParts[2], 10) || 0;
  //   } else if (selectedTime === null) {
  //     // If null is passed, use midnight
  //     return null;
  //   }

  //   const combinedDate = new Date(
  //     logDate.getFullYear(),
  //     logDate.getMonth(),
  //     logDate.getDate(),
  //     timeHours,
  //     timeMinutes,
  //     timeSeconds
  //   );

  //   const epochTime = Math.floor(combinedDate.getTime() / 1000); // Convert to epoch time (seconds)

  //   return epochTime;
  // };

  // // Function to calculate duration in HH:MM:SS format
  // const calculateDuration = (startTimeEpoch: number, endTimeEpoch: number) => {
  //   if (!startTimeEpoch || !endTimeEpoch) return "00:00";

  //   const startTime = new Date(startTimeEpoch * 1000);
  //   const endTime = new Date(endTimeEpoch * 1000);

  //   // Clone endTime to potentially adjust for next day calculation
  //   let adjustedEndTime = new Date(endTime);

  //   // Check if end time is earlier than start time (implying next day)
  //   const startHours = startTime.getHours();
  //   const startMinutes = startTime.getMinutes();
  //   const startSeconds = startTime.getSeconds();
  //   const endHours = endTime.getHours();
  //   const endMinutes = endTime.getMinutes();
  //   const endSeconds = endTime.getSeconds();

  //   // Calculate total seconds for both times
  //   const startTotalSeconds =
  //     startHours * 3600 + startMinutes * 60 + startSeconds;
  //   const endTotalSeconds = endHours * 3600 + endMinutes * 60 + endSeconds;

  //   // If end time appears earlier, add a day to the end time
  //   if (endTotalSeconds < startTotalSeconds) {
  //     adjustedEndTime.setDate(adjustedEndTime.getDate() + 1);
  //   }

  //   const timeDifferenceMs = adjustedEndTime.getTime() - startTime.getTime();
  //   const totalSeconds = Math.floor(timeDifferenceMs / 1000);
  //   const hours = Math.floor(totalSeconds / 3600);
  //   const minutes = Math.floor((totalSeconds % 3600) / 60);
  //   const seconds = Math.floor(totalSeconds % 60);

  //   return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
  //     2,
  //     "0"
  //   )}:${String(seconds).padStart(2, "0")}`;
  // };

  // // Handler for manager start time change
  // const handleManagerStartChange = (e: any) => {
  //   const selectedTime = e.value;

  //   const currentTimelogdetailsID = props.rowData.timelogdetailsID;
  //   const currentUserID = props.rowData.userID;
  //   const currentProjectID = props.rowData.projectID;

  //   // Get current data for this specific row, if it exists
  //   const existingRowData = props.selectedManagerTimeDataArray.find(
  //     (item: any) => item.timelogdetailsID === currentTimelogdetailsID
  //   ) || {
  //     manager_start_time: null,
  //     manager_end_time: null,
  //     manager_duration: null,
  //     timelogdetailsID: currentTimelogdetailsID,
  //     userID: currentUserID,
  //     projectID: currentProjectID,
  //     timeLogID: props.rowData.timeLogID,
  //   };

  //   // Ensure log_date is in seconds
  //   const logDateInSeconds =
  //     typeof props.rowData.log_date === "number" &&
  //     props.rowData.log_date > 10000000000
  //       ? props.rowData.log_date / 1000 // Convert from milliseconds to seconds if needed
  //       : props.rowData.log_date;

  //   // Get the epoch time for the selected start time
  //   const combinedEpoch = combineDateWithTime(logDateInSeconds, selectedTime);

  //   if (!combinedEpoch) return; // Exit if invalid time

  //   // Create updated data for this specific row
  //   const updatedData = {
  //     ...existingRowData,
  //     manager_start_time: combinedEpoch,
  //   };

  //   // Recalculate duration if end_time is set
  //   if (updatedData.manager_end_time) {
  //     updatedData.manager_duration = calculateDuration(
  //       combinedEpoch,
  //       updatedData.manager_end_time
  //     );
  //   }

  //   // Update the selectedManagerTimeDataArray
  //   const existingIndex = props.selectedManagerTimeDataArray.findIndex(
  //     (item: any) => item.timelogdetailsID === currentTimelogdetailsID
  //   );

  //   if (existingIndex > -1) {
  //     // Update existing record
  //     const updatedArray = [...props.selectedManagerTimeDataArray];
  //     updatedArray[existingIndex] = updatedData;
  //     props.setSelectedManagerTimeDataArray(updatedArray);
  //   } else {
  //     // Add new record
  //     props.setSelectedManagerTimeDataArray([
  //       ...props.selectedManagerTimeDataArray,
  //       updatedData,
  //     ]);
  //   }
  // };

  // // Handler for manager end time change
  // const handleManagerEndChange = (e: any) => {
  //   const selectedTime = e.value;

  //   const currentTimelogdetailsID = props.rowData.timelogdetailsID;
  //   const currentUserID = props.rowData.userID;
  //   const currentProjectID = props.rowData.projectID;

  //   // Get current data for this specific row, if it exists
  //   const existingRowData = props.selectedManagerTimeDataArray.find(
  //     (item: any) => item.timelogdetailsID === currentTimelogdetailsID
  //   ) || {
  //     manager_start_time: null,
  //     manager_end_time: null,
  //     manager_duration: null,
  //     userID: currentUserID,
  //     projectID: currentProjectID,
  //     timelogdetailsID: currentTimelogdetailsID,
  //     timeLogID: props.rowData.timeLogID,
  //   };

  //   // Ensure log_date is in seconds
  //   const logDateInSeconds =
  //     typeof props.rowData.log_date === "number" &&
  //     props.rowData.log_date > 10000000000
  //       ? props.rowData.log_date / 1000 // Convert from milliseconds to seconds if needed
  //       : props.rowData.log_date;

  //   // Get the epoch time for the selected end time
  //   const combinedEpoch = combineDateWithTime(logDateInSeconds, selectedTime);

  //   if (!combinedEpoch) return; // Exit if invalid time

  //   // Create updated data for this specific row
  //   const updatedData = {
  //     ...existingRowData,
  //     manager_end_time: combinedEpoch,
  //   };

  //   // Recalculate duration if start_time is set
  //   if (updatedData.manager_start_time) {
  //     updatedData.manager_duration = calculateDuration(
  //       updatedData.manager_start_time,
  //       combinedEpoch
  //     );
  //   }

  //   // Update the selectedManagerTimeDataArray
  //   const existingIndex = props.selectedManagerTimeDataArray.findIndex(
  //     (item: any) => item.timelogdetailsID === currentTimelogdetailsID
  //   );

  //   if (existingIndex > -1) {
  //     // Update existing record
  //     const updatedArray = [...props.selectedManagerTimeDataArray];
  //     updatedArray[existingIndex] = updatedData;
  //     props.setSelectedManagerTimeDataArray(updatedArray);
  //   } else {
  //     // Add new record
  //     props.setSelectedManagerTimeDataArray([
  //       ...props.selectedManagerTimeDataArray,
  //       updatedData,
  //     ]);
  //   }
  // };

  // // Find the current row's data in the selectedManagerTimeDataArray
  // const currentRowData = props.selectedManagerTimeDataArray.find(
  //   (item: any) => item.timelogdetailsID === props.rowData.timelogdetailsID
  // );

  // return (
  //   <>
  //     <div className="tw-flex tw-align-items-center tw-gap-2 tw-w-full tw-max-w-[320px] tw-min-w-[320px]">
  //       {/* Manager Start Time */}
  //       <div className="tw-flex tw-flex-col tw-items-start">
  //         <span className="tw-flex tw-gap-2">
  //           {isEdit ? (
  //             <Calendar
  //               value={
  //                 currentRowData?.manager_start_time
  //                   ? new Date(currentRowData.manager_start_time * 1000)
  //                   : null
  //               }
  //               onChange={handleManagerStartChange}
  //               timeOnly
  //               hourFormat="24"
  //               className="tw-border tw-border-solid tw-border-[#E2E2E2] tw-px-2 tw-py-[3px] tw-rounded tw-text-sm tw-w-14 tw-pl-[10px] tw-ml-[12px] tw-mr-[36px]"
  //             />
  //           ) : (
  //             <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4 tw-ml-[12px] tw-mr-5">
  //               {currentRowData?.manager_start_time
  //                 ? convertEpochToTime(currentRowData.manager_start_time)
  //                 : "--:--"}
  //             </span>
  //           )}
  //         </span>
  //         <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4 tw-ml-[12px]">
  //           Start Time
  //         </span>
  //       </div>

  //       {/* Manager End Time */}
  //       <div className="tw-flex tw-flex-col tw-items-start">
  //         <span className="tw-flex tw-gap-2">
  //           {isEdit ? (
  //             <Calendar
  //               value={
  //                 currentRowData?.manager_end_time
  //                   ? new Date(currentRowData.manager_end_time * 1000)
  //                   : null
  //               }
  //               onChange={handleManagerEndChange}
  //               timeOnly
  //               hourFormat="24"
  //               className="tw-border tw-border-solid tw-border-[#E2E2E2] tw-px-2 tw-py-[3px] tw-rounded tw-text-sm tw-w-14 tw-pl-[10px] tw-mr-[36px]"
  //             />
  //           ) : (
  //             <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4 tw-mr-5">
  //               {currentRowData?.manager_end_time
  //                 ? convertEpochToTime(currentRowData.manager_end_time)
  //                 : "--:--"}
  //             </span>
  //           )}
  //         </span>
  //         <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
  //           End Time
  //         </span>
  //       </div>

  //       {/* Manager Duration */}
  //       <div className="tw-flex tw-flex-col tw-items-start">
  //         <span className="tw-flex tw-gap-2">
  //           {isEdit ? (
  //             <InputText
  //               value={currentRowData?.manager_duration ?? "00:00"}
  //               className="tw-border tw-border-solid tw-border-[#E2E2E2] tw-px-2 tw-py-[3px] tw-rounded tw-text-sm tw-w-14 tw-pl-[10px]"
  //               readOnly
  //             />
  //           ) : (
  //             <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4">
  //               {currentRowData?.manager_duration ?? "00:00"}
  //             </span>
  //           )}
  //         </span>
  //         <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
  //           Total Hours
  //         </span>
  //       </div>
  //     </div>
  //   </>
  // );

  const isEdit = props.editAppTimeRowIndices.includes(
    props.rowData.timelogdetailsID
  );

  // Function to combine date from log_date with selected time
  const combineDateWithTime = (
    logDateEpoch: number,
    selectedTime: Date | string | null
  ) => {
    // Ensure logDateEpoch is in seconds
    const logDateInSeconds = logDateEpoch;
    const logDate = new Date(logDateInSeconds * 1000); // Convert log_date to a Date object

    // Handle different input types for selectedTime
    let timeHours = 0;
    let timeMinutes = 0;
    let timeSeconds = 0;

    if (selectedTime instanceof Date) {
      // If it's a Date object from Calendar selection
      timeHours = selectedTime.getHours();
      timeMinutes = selectedTime.getMinutes();
      timeSeconds = selectedTime.getSeconds();
    } else if (typeof selectedTime === "string") {
      // If it's a string from manual input (assuming format like "HH:MM" or "HH:MM:SS")
      const timeParts = selectedTime.split(":");
      timeHours = parseInt(timeParts[0], 10) || 0;
      timeMinutes = parseInt(timeParts[1], 10) || 0;
      timeSeconds = parseInt(timeParts[2], 10) || 0;
    } else if (selectedTime === null) {
      // If null is passed, use midnight
      return null;
    }

    const combinedDate = new Date(
      logDate.getFullYear(),
      logDate.getMonth(),
      logDate.getDate(),
      timeHours,
      timeMinutes,
      timeSeconds
    );

    const epochTime = Math.floor(combinedDate.getTime() / 1000); // Convert to epoch time (seconds)

    return epochTime;
  };

  // Function to calculate duration in HH:MM:SS format
  const calculateDuration = (startTimeEpoch: number, endTimeEpoch: number) => {
    if (!startTimeEpoch || !endTimeEpoch) return "00:00";

    const startTime = new Date(startTimeEpoch * 1000);
    const endTime = new Date(endTimeEpoch * 1000);

    // Clone endTime to potentially adjust for next day calculation
    let adjustedEndTime = new Date(endTime);

    // Check if end time is earlier than start time (implying next day)
    const startHours = startTime.getHours();
    const startMinutes = startTime.getMinutes();
    const startSeconds = startTime.getSeconds();
    const endHours = endTime.getHours();
    const endMinutes = endTime.getMinutes();
    const endSeconds = endTime.getSeconds();

    // Calculate total seconds for both times
    const startTotalSeconds =
      startHours * 3600 + startMinutes * 60 + startSeconds;
    const endTotalSeconds = endHours * 3600 + endMinutes * 60 + endSeconds;

    // If end time appears earlier, add a day to the end time
    if (endTotalSeconds < startTotalSeconds) {
      adjustedEndTime.setDate(adjustedEndTime.getDate() + 1);
    }

    const timeDifferenceMs = adjustedEndTime.getTime() - startTime.getTime();
    const totalSeconds = Math.floor(timeDifferenceMs / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}`;
  };

  // Handler for app start time change
  const handleManagerStartChange = (e: any) => {
    // Handle both Calendar selection and manual input
    const selectedTime = e.value;

    if (!selectedTime && typeof e.target?.value === "string") {
      // Handle manual text input case
      handleManualTimeInput(e.target.value, "manager_start_time");
      return;
    }

    // Rest of your existing code for Calendar selection
    const currentTimelogdetailsID = props.rowData.timelogdetailsID;
    const currentUserID = props.rowData.userID;
    const currentProjectID = props.rowData.projectID;

    // Get current data for this specific row, if it exists
    const existingRowData = props.selectedAppTimeDataArray.find(
      (item: any) => item.timelogdetailsID === currentTimelogdetailsID
    ) || {
      manager_start_time: props.rowData.manager_start_time,
      manager_end_time: props.rowData.manager_end_time,
      manager_duration: props.rowData.manager_duration,
      timelogdetailsID: currentTimelogdetailsID,
      userID: currentUserID,
      projectID: currentProjectID,
      timeLogID: props.rowData.timeLogID,
    };

    // Ensure log_date is in seconds
    const logDateInSeconds =
      typeof props.rowData.log_date === "number" &&
      props.rowData.log_date > 10000000000
        ? props.rowData.log_date / 1000 // Convert from milliseconds to seconds if needed
        : props.rowData.log_date;

    // Get the epoch time for the selected start time
    const combinedEpoch = combineDateWithTime(logDateInSeconds, selectedTime);

    if (!combinedEpoch) return; // Exit if invalid time

    // Create updated data for this specific row
    const updatedData = {
      ...existingRowData,
      manager_start_time: combinedEpoch,
    };

    // Recalculate duration if end_time is set
    if (updatedData.manager_end_time) {
      updatedData.manager_duration = calculateDuration(
        combinedEpoch,
        updatedData.manager_end_time
      );
    }

    // Update the selectedAppTimeDataArray
    const existingIndex = props.selectedAppTimeDataArray.findIndex(
      (item: any) => item.timelogdetailsID === currentTimelogdetailsID
    );

    if (existingIndex > -1) {
      // Update existing record
      const updatedArray = [...props.selectedAppTimeDataArray];
      updatedArray[existingIndex] = updatedData;
      props.setSelectedAppTimeDataArray(updatedArray);
    } else {
      // Add new record
      props.setSelectedAppTimeDataArray([
        ...props.selectedAppTimeDataArray,
        updatedData,
      ]);
    }
  };

  // Handler for app end time change
  const handleManagerEndChange = (e: any) => {
    // Handle both Calendar selection and manual input
    const selectedTime = e.value;

    if (!selectedTime && typeof e.target?.value === "string") {
      // Handle manual text input case
      handleManualTimeInput(e.target.value, "manager_end_time");
      return;
    }

    // Rest of your existing code for Calendar selection
    const currentTimelogdetailsID = props.rowData.timelogdetailsID;
    const currentUserID = props.rowData.userID;
    const currentProjectID = props.rowData.projectID;

    // Get current data for this specific row, if it exists
    const existingRowData = props.selectedAppTimeDataArray.find(
      (item: any) => item.timelogdetailsID === currentTimelogdetailsID
    ) || {
      manager_start_time: props.rowData.manager_start_time,
      manager_end_time: props.rowData.manager_end_time,
      manager_duration: props.rowData.manager_duration,
      userID: currentUserID,
      projectID: currentProjectID,
      timelogdetailsID: currentTimelogdetailsID,
      timeLogID: props.rowData.timeLogID,
    };

    // Ensure log_date is in seconds
    const logDateInSeconds =
      typeof props.rowData.log_date === "number" &&
      props.rowData.log_date > 10000000000
        ? props.rowData.log_date / 1000 // Convert from milliseconds to seconds if needed
        : props.rowData.log_date;

    // Get the epoch time for the selected end time
    const combinedEpoch = combineDateWithTime(logDateInSeconds, selectedTime);

    if (!combinedEpoch) return; // Exit if invalid time

    // Create updated data for this specific row
    const updatedData = {
      ...existingRowData,
      manager_end_time: combinedEpoch,
    };

    // Recalculate duration if manager_start_time is set
    if (updatedData.manager_start_time) {
      updatedData.manager_duration = calculateDuration(
        updatedData.manager_start_time,
        combinedEpoch
      );
    }

    // Update the selectedAppTimeDataArray
    const existingIndex = props.selectedAppTimeDataArray.findIndex(
      (item: any) => item.timelogdetailsID === currentTimelogdetailsID
    );

    if (existingIndex > -1) {
      // Update existing record
      const updatedArray = [...props.selectedAppTimeDataArray];
      updatedArray[existingIndex] = updatedData;
      props.setSelectedAppTimeDataArray(updatedArray);
    } else {
      // Add new record
      props.setSelectedAppTimeDataArray([
        ...props.selectedAppTimeDataArray,
        updatedData,
      ]);
    }
  };

  // New function to handle manual time input
  const handleManualTimeInput = (
    timeString: string,
    timeType: "manager_start_time" | "manager_end_time"
  ) => {
    // Validate time string (basic validation)
    if (!timeString.match(/^([01]?[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/)) {
      // Invalid time format
      return;
    }

    const currentTimelogdetailsID = props.rowData.timelogdetailsID;
    const currentUserID = props.rowData.userID;
    const currentProjectID = props.rowData.projectID;

    // Get current data for this specific row
    const existingRowData = props.selectedAppTimeDataArray.find(
      (item: any) => item.timelogdetailsID === currentTimelogdetailsID
    ) || {
      manager_start_time: props.rowData.manager_start_time,
      manager_end_time: props.rowData.manager_end_time,
      manager_duration: props.rowData.manager_duration,
      timelogdetailsID: currentTimelogdetailsID,
      userID: currentUserID,
      projectID: currentProjectID,
      timeLogID: props.rowData.timeLogID,
    };

    // Ensure log_date is in seconds
    const logDateInSeconds =
      typeof props.rowData.log_date === "number" &&
      props.rowData.log_date > 10000000000
        ? props.rowData.log_date / 1000
        : props.rowData.log_date;

    // Parse the time string to create time components
    const [hours, minutes, seconds = "0"] = timeString
      .split(":")
      .map((num) => parseInt(num, 10));

    // Create a temporary date object with the current time
    const tempDate = new Date();
    tempDate.setHours(
      hours,
      minutes,
      typeof seconds === "string" ? parseInt(seconds, 10) : seconds
    );

    // Get the epoch time
    const combinedEpoch = combineDateWithTime(logDateInSeconds, tempDate);

    if (!combinedEpoch) return; // Exit if invalid time

    // Create updated data
    const updatedData = {
      ...existingRowData,
      [timeType]: combinedEpoch,
    };

    // Recalculate duration if both start and end times are set
    if (updatedData.manager_start_time && updatedData.manager_end_time) {
      updatedData.manager_duration = calculateDuration(
        updatedData.manager_start_time,
        updatedData.manager_end_time
      );
    }

    // Update the data array
    const existingIndex = props.selectedAppTimeDataArray.findIndex(
      (item: any) => item.timelogdetailsID === currentTimelogdetailsID
    );

    if (existingIndex > -1) {
      const updatedArray = [...props.selectedAppTimeDataArray];
      updatedArray[existingIndex] = updatedData;
      props.setSelectedAppTimeDataArray(updatedArray);
    } else {
      props.setSelectedAppTimeDataArray([
        ...props.selectedAppTimeDataArray,
        updatedData,
      ]);
    }
  };

  // Find the current row's data in the selectedAppTimeDataArray
  const currentRowData = props.selectedAppTimeDataArray.find(
    (item: any) => item.timelogdetailsID === props.rowData.timelogdetailsID
  );

  return (
    <>
      {props.isManagerRejectView ? (
        <div className="tw-flex tw-align-items-center tw-gap-2 tw-w-full tw-max-w-[320px] tw-min-w-[320px]">
          {/* App Start Time */}
          <div className="tw-flex tw-flex-col tw-items-start">
            <span className="tw-flex tw-gap-2">
              {isEdit ? (
                <Calendar
                  value={
                    currentRowData?.manager_start_time
                      ? new Date(currentRowData.manager_start_time * 1000)
                      : props.rowData.manager_start_time
                      ? new Date(props.rowData.manager_start_time * 1000)
                      : null
                  }
                  onChange={handleManagerStartChange}
                  timeOnly
                  hourFormat="24"
                  className="tw-border tw-border-solid tw-border-[#E2E2E2] tw-px-2 tw-py-[3px] tw-rounded tw-text-sm tw-w-16 tw-pl-[10px] tw-ml-[12px] tw-mr-[36px]"
                />
              ) : (
                <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4 tw-ml-[12px] tw-mr-5">
                  {props.rowData.manager_start_time
                    ? convertEpochToTime(props.rowData.manager_start_time)
                    : "--:--"}
                </span>
              )}
            </span>
            <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4 tw-ml-[12px]">
              Start Time
            </span>
          </div>

          {/* App End Time */}
          <div className="tw-flex tw-flex-col tw-items-start">
            <span className="tw-flex tw-gap-2">
              {isEdit ? (
                <Calendar
                  value={
                    currentRowData?.manager_end_time
                      ? new Date(currentRowData.manager_end_time * 1000)
                      : props.rowData.manager_end_time
                      ? new Date(props.rowData.manager_end_time * 1000)
                      : null
                  }
                  onChange={handleManagerEndChange}
                  timeOnly
                  hourFormat="24"
                  className="tw-border tw-border-solid tw-border-[#E2E2E2] tw-px-2 tw-py-[3px] tw-rounded tw-text-sm tw-w-16 tw-pl-[10px] tw-mr-[36px]"
                />
              ) : (
                <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4 tw-mr-5">
                  {props.rowData.manager_end_time
                    ? convertEpochToTime(props.rowData.manager_end_time)
                    : "--:--"}
                </span>
              )}
            </span>
            <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
              End Time
            </span>
          </div>

          {/* Manager Duration */}
          <div className="tw-flex tw-flex-col tw-items-start">
            <span className="tw-flex tw-gap-2">
              {isEdit ? (
                <InputText
                  value={
                    removeSecFromDuration(currentRowData?.manager_duration) ??
                    removeSecFromDuration(props.rowData.manager_duration) ??
                    "00:00"
                  }
                  className="tw-border tw-border-solid tw-border-[#E2E2E2] tw-px-2 tw-py-[3px] tw-rounded tw-text-sm tw-w-16 tw-pl-[10px]"
                  readOnly
                />
              ) : (
                <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4">
                  {props.rowData.manager_duration
                    ? removeSecFromDuration(props.rowData.manager_duration)
                    : "--:--"}
                </span>
              )}
            </span>
            <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
              Total Hours
            </span>
          </div>
        </div>
      ) : (
        <div className="tw-grid tw-grid-cols-3 tw-gap-3 tw-max-w-[320px] tw-min-w-[320px]">
          <div className="tw-flex tw-flex-col tw-items-start">
            <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4">
              {props.rowData.manager_start_time
                ? convertEpochToTime(props.rowData.manager_start_time)
                : "--:--"}
            </span>
            <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
              Start Time
            </span>
          </div>
          <div className="tw-flex tw-flex-col tw-items-start">
            <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4">
              {props.rowData.manager_end_time
                ? convertEpochToTime(props.rowData.manager_end_time)
                : "--:--"}
            </span>
            <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
              End Time
            </span>
          </div>
          <div className="tw-flex tw-flex-col tw-items-start">
            <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4">
              {props.rowData.manager_duration
                ? removeSecFromDuration(props.rowData.manager_duration)
                : "--:--"}
            </span>
            <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
              Total Hours
            </span>
          </div>
        </div>
      )}
    </>
  );
};

export const descriptionBodyTemplate = (rowData: any) => {
  return (
    <>
      <Tooltip
        target=".in-project-desc"
        mouseTrack
        mouseTrackLeft={10}
        position="bottom"
        className="tw-max-w-sm tw-text-sm"
      />
      {/* <div className="tw-text-sm tw-text-[#64748B] tw-font-medium tw-leading-4 tw-break-words tw-whitespace-normal">
        {rowData.description}
      </div> */}
      {rowData.description && (
        <span
          className="tw-ml-2 in-project-desc"
          data-pr-tooltip={
            rowData.description.length > 50 ? rowData.description : undefined
          }
        >
          {rowData.description.length > 50
            ? `${rowData.description.substring(0, 50)}......`
            : rowData.description}
        </span>
      )}
    </>
  );
};

export const trackerTimeBodyTemplateViewOnly = (rowData: any, options: any) => {
  if (options.rowIndex !== 0) return null;
  return (
    <div className="tw-text-sm tw-text-[#64748B] tw-font-medium tw-leading-4 tw-break-words tw-whitespace-normal">
      <div className="tw-grid tw-grid-cols-3 tw-gap-3 tw-max-w-[320px] tw-min-w-[320px]">
        <div className="tw-flex tw-flex-col tw-items-start">
          <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4 tw-ml-[12px]">
            {rowData.tracker_punch_in &&
              convertEpochToTime(rowData.tracker_punch_in)}
          </span>
          <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4 tw-ml-[12px]">
            Start Time
          </span>
        </div>
        <div className="tw-flex tw-flex-col tw-items-start">
          <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4">
            {rowData.tracker_punch_out &&
              convertEpochToTime(rowData.tracker_punch_out)}
          </span>
          <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
            End Time
          </span>
        </div>
        <div className="tw-flex tw-flex-col tw-items-start">
          <span className="tw-text-sm tw-text-[#293646] tw-font-semibold tw-leading-4">
            {removeSecFromDuration(rowData?.tracker_duration)}:00
          </span>
          <span className="tw-text-xs tw-text-[#6A7D94] tw-font-semibold tw-leading-4">
            Total Hours
          </span>
        </div>
      </div>
    </div>
  );
};
